<template>
	<div class="receipts-control">
		<div :class="privileges.includes(sec) ? 'upload-btn' : 'un-upload-btn'" @click="onUpdate()">
			<v-icon left color="#FFFFFF">mdi-plus</v-icon>
			<span v-if="$vuetify.breakpoint.mdAndDown">UPLOAD</span>
			<span v-else>Upload Expenses</span>
		</div>
		<div :class="control && privileges.includes(sec)? 'delete-btn': 'un-delete-btn'" class="mx-3" @click="onDelete()">
			<span v-if="$vuetify.breakpoint.mdAndDown">DELETE</span>
			<span v-else>Delete Expenses</span>
		</div>
		<div :class="control && privileges.includes(sec)? 'create-btn': 'un-create-btn'" @click="omCreate()">
			<span v-if="$vuetify.breakpoint.mdAndDown">CREATE</span>
			<span v-else>Create Claim</span>
		</div>
	</div>
</template>
<script>
const SEC = 'Sec';

export default {
	name: 'ReceiptButton',
	props: {
		control: {
			type: Boolean,
			default: false
		},
		privileges: {
			type: Array,
			default: () => []
		}
	},
	data() {
		this.sec = SEC;
		return {}
	},
	methods: {
		onUpdate() {
			if (this.privileges.includes(this.sec)) {
				this.$emit('update');
			}
		},
		onDelete() {
			if (this.control && this.privileges.includes(this.sec)) {
				this.$emit('delete');
			}
		},
		omCreate() {
			if (this.control && this.privileges.includes(this.sec)) {
				this.$emit('create');
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.receipts-control {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.receipts-control-xs {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.delete-btn {
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: rgba(25, 42, 62, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
	border-radius: 4px;
	margin-right: 10px;
	&:hover {
		cursor: pointer;
	}
}
.un-delete-btn {
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: rgba(25, 42, 62, 0.3);
	border: 1px solid rgba(25, 42, 62, 0.3);
	border-radius: 4px;
}
.create-btn {
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: #FFFFFF;
	background: #00AAFD;
	border-radius: 4px;
	&:hover {
		cursor: pointer;
	}
}
.un-create-btn {
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: #FFFFFF;
	background: rgba(25, 42, 62, 0.3);
	border-radius: 4px;
}
.upload-btn {
  height: 36px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 14px;
  background: #00AAFD;
  border-radius: 4px;
  color: #FFFFFF;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  &:hover {
    cursor: pointer;
  }
}
.un-upload-btn {
	height: 36px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 14px;
  background: rgba(25, 42, 62, 0.3);
  border-radius: 4px;
  color: #FFFFFF;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
}
</style>